import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { arrow, autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react';
import { Portal } from '@headlessui/react';
import { Button } from '../Button/Button';
export const TutorialStepper = forwardRef(({ steps, show, stepControlRef }, ref) => {
    const [showTutorial, setShowTutorial] = useState(show);
    const [stepIndex, setStepIndex] = useState(0);
    useEffect(() => {
        setShowTutorial(show);
    }, [show]);
    const handleNextClick = () => {
        if (!show)
            return;
        if (stepIndex === steps.length - 1) {
            setShowTutorial(false);
        }
        else {
            setStepIndex(stepIndex + 1);
        }
    };
    const handlePrevClick = () => {
        if (!show)
            return;
        if (stepIndex > 0)
            setStepIndex(stepIndex - 1);
    };
    useImperativeHandle(ref || stepControlRef, () => ({
        handleNextClick,
        handlePrevClick,
    }));
    if (!showTutorial)
        return null;
    return _jsx(TutorialStep, { steps: steps, stepIndex: stepIndex, onNext: handleNextClick, onPrev: handlePrevClick });
});
export const TutorialStep = ({ steps, stepIndex, onNext, onPrev, }) => {
    const [step, setStep] = useState(steps[stepIndex]);
    const arrowRef = useRef(null);
    useEffect(() => {
        setStep(steps[stepIndex]);
    }, [steps, stepIndex]);
    const { refs, floatingStyles, middlewareData } = useFloating({
        whileElementsMounted: autoUpdate,
        middleware: [offset(10), flip(), shift({ padding: 5 }), arrow({ element: arrowRef })],
    });
    useEffect(() => {
        if (!step)
            return;
        const targetSelector = step.target;
        const targetElement = document.querySelector(targetSelector);
        if (targetElement) {
            refs.setReference(targetElement);
        }
    }, [step]);
    if (!step)
        return null;
    const arrowStyles = {
        left: middlewareData.arrow?.x != null ? `${middlewareData.arrow.x}px` : '',
        top: middlewareData.arrow?.y != null ? `${middlewareData.arrow.y}px` : '-9px',
    };
    return (_jsx(Portal, { children: _jsxs("div", { ref: refs.setFloating, style: {
                ...floatingStyles,
            }, className: "z-[500] flex flex-col gap-y-1 rounded border bg-white p-2 text-xs", children: [_jsx("div", { ref: arrowRef, className: "absolute size-4 border-l border-t bg-white", style: {
                        ...arrowStyles,
                        transform: 'rotate(45deg)',
                    }, children: _jsx("div", { className: "bg-primary-400 absolute -left-4 -top-4 flex size-8 items-center justify-center rounded-full bg-opacity-30", style: {
                            animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                        }, children: _jsx("div", { className: "bg-primary-400 size-2 rounded-full" }) }) }), _jsx("div", { className: "pb-1", children: step.content }), _jsxs("div", { className: "flex justify-between border-t pt-1", children: [stepIndex <= 0 ? (_jsx("div", {})) : (_jsx(Button, { className: "text-primary-400", onClick: onPrev, children: "Prev" })), _jsx(Button, { className: "text-primary-400", onClick: onNext, children: stepIndex === steps.length - 1 ? 'Finish' : 'Next' })] })] }) }));
};
//# sourceMappingURL=tutorial-stepper.js.map